import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "uk-padding csa-gallery-mg" }
const _hoisted_2 = { class: "uk-container" }
const _hoisted_3 = { "data-uk-filter": "target: .js-filter" }
const _hoisted_4 = { class: "uk-subnav uk-subnav-pill uk-flex-center uk-margin-medium-bottom impx-gallery-filter uk-margin-small-top impx-margin-bottom" }
const _hoisted_5 = ["data-uk-filter-control"]
const _hoisted_6 = { href: "#" }
const _hoisted_7 = {
  class: "js-filter uk-child-width-1-4@xl uk-child-width-1-4@l uk-child-width-1-4@m uk-child-width-1-3@s uk-grid-medium uk-margin-small-bottom",
  "data-uk-grid": "masonry : true",
  "data-uk-lightbox": ""
}
const _hoisted_8 = ["href", "data-caption"]
const _hoisted_9 = ["src", "alt"]
const _hoisted_10 = { class: "uk-transition-fade uk-position-cover uk-overlay uk-overlay-primary" }



export default /*@__PURE__*/_defineComponent({
  __name: 'GalleryContent',
  props: {
  galleries:{ type: Array, default: () => [] },
  galleryTypes:{ type: Array, default: () => [] }
},
  setup(__props) {

const props = __props;

console.log("Test------------------")
console.log(props.galleries)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("ul", _hoisted_4, [
          _cache[0] || (_cache[0] = _createElementVNode("li", { "data-uk-filter-control": ".all" }, [
            _createElementVNode("a", { href: "#" }, "Tout")
          ], -1)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.galleryTypes, (type) => {
            return (_openBlock(), _createElementBlock("li", {
              key: type.uid,
              "data-uk-filter-control": '.' + type.uid
            }, [
              _createElementVNode("a", _hoisted_6, _toDisplayString(type.label), 1)
            ], 8, _hoisted_5))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_7, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.galleries, (galleryImg, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass('.' + galleryImg.type+'  all'),
              key: index
            }, [
              _createElementVNode("a", {
                class: "uk-inline-clip uk-transition-toggle",
                href: galleryImg.url,
                "data-caption": galleryImg.title
              }, [
                _createElementVNode("img", {
                  src: galleryImg.url,
                  alt: galleryImg.title
                }, null, 8, _hoisted_9),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("h5", null, _toDisplayString(galleryImg.title), 1)
                ])
              ], 8, _hoisted_8)
            ], 2))
          }), 128))
        ])
      ])
    ])
  ]))
}
}

})